import { render, staticRenderFns } from "./composite.vue?vue&type=template&id=4ef73952&scoped=true&"
import script from "./composite.vue?vue&type=script&lang=js&"
export * from "./composite.vue?vue&type=script&lang=js&"
import style0 from "./composite.vue?vue&type=style&index=0&id=4ef73952&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ef73952",
  null
  
)

export default component.exports